<template>
  <div class="app-container">
    <el-card
      v-loading="cardopenloading"
      element-loading-text="加载中"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <el-row class="panel-group">
        <el-col :span="4">
          <div class="card-panel">
            <div class="card-panel-description">
              <div class="card-panel-text">支撑品牌数</div>
              <span data-v-6723c96e class="card-acuser-num">{{
                allBrandOrStore.brands
              }}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="card-panel">
            <div class="card-panel-description">
              <div class="card-panel-text">总处理单据数量</div>
              <span data-v-6723c96e class="card-acuser-num">
                {{ allVouchers.allOrderNums }}
              </span>
            </div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="card-panel">
            <div class="card-panel-description">
              <div class="card-panel-text">总处理凭证数量</div>
              <span data-v-6723c96e class="card-acuser-num">
                {{ allVouchers.allVoucherNums }}
              </span>
            </div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="card-panel">
            <div class="card-panel-description">
              <div class="card-panel-text">总处理金额</div>
              <span data-v-6723c96e class="card-acuser-num">
                {{ allVouchers.allVoucherAmts }}
              </span>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <div class="card-panel">
            <div class="card-panel-description">
              <div class="card-panel-text">支撑门店数</div>
              <span data-v-6723c96e class="card-acuser-num">{{
                allBrandOrStore.stores
              }}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="card-panel">
            <div class="card-panel-description">
              <div class="card-panel-text">日均处理单据数量</div>
              <span data-v-6723c96e class="card-acuser-num">
                {{ allVouchers.orderNumByDay }}
              </span>
            </div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="card-panel">
            <div class="card-panel-description">
              <div class="card-panel-text">日均处理凭证数量</div>
              <span data-v-6723c96e class="card-acuser-num">
                {{ allVouchers.voucherNumByDay }}
              </span>
            </div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="card-panel">
            <div class="card-panel-description">
              <div class="card-panel-text">日均处理金额</div>
              <span data-v-6723c96e class="card-acuser-num">
                {{ allVouchers.voucherAmtByDay }}
              </span>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-card
      class="welcome-card note"
      style="margin-top:20px;"
      v-loading="card2openloading"
      element-loading-text="加载中"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <el-row>
        <el-col :span="15">
          <el-radio-group
            v-model="datePeriod"
            size="mini"
            @change="changeDatePeriod"
            class
          >
            <el-radio-button
              v-for="item in periodList"
              :key="item"
              :label="item"
              :value="item"
              >{{ item }}</el-radio-button
            >
          </el-radio-group>
          <div class="content-title"><span>数据量趋势图</span></div>
          <ve-histogram
            :data="histogramChartDataWeek"
            :settings="histogramChartSettingsWeek"
            :mark-line="histogramChartMarkLine"
          ></ve-histogram>
        </el-col>
        <el-col :span="9">
          <div class="content-title">
            <!-- <span>活跃租户Top5/不活跃租户Top5</span> -->
            <el-switch
              style="display: inline-block; margin-right: 20px"
              v-model="isShowActive"
              active-color="#13ce66"
              inactive-color="#909399"
              active-text="活跃租户Top5"
              inactive-text="不活跃租户Top5"
              @change="showAcitiveOr"
            ></el-switch>
          </div>
          <el-table
            :row-style="{ height: '64px' }"
            :data="ActivyTenantListFor5"
            size="mini"
            style="width: 100%;margin-top:18px"
          >
            <el-table-column
              type="index"
              align="center"
              :resizable="false"
              label="名次"
              width="100"
            >
              <template slot-scope="scope">
                <span class="no"></span>
                <span class="no"> </span>
                <span class="no"></span>
                <span class="no">{{ scope.$index + 1 }} </span>
              </template>
            </el-table-column>
            <el-table-column prop="tenancyName" label="租户"></el-table-column>
            <el-table-column
              prop="activityValue"
              label="活跃度"
            ></el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-card>
    <el-card
      class="welcome-card note"
      style="margin-top:20px;"
      v-loading="card3openloading"
      element-loading-text="加载中"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <el-row>
        <el-col :span="14">
          <div class="chinaecharts">
            <div id="mapChart" ref="mapChart"></div>
          </div>
        </el-col>
        <el-col :span="10">
          <div class="content-title" style="width:50%">
            <span>模块单据数量占比</span>
          </div>
          <ve-ring
            :data="ringChartData"
            :title="title"
            :settings="ringChartSettings"
          ></ve-ring>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import "echarts/map/js/china.js"; // 引入中国地图数据
import echarts from "echarts";
import Vue from "vue";
import VCharts from "v-charts";
import config from "@/common/config.js";
import AjaxHelper from "@/common/js/AjaxHelper";
import pagerBar from "@/views/pager/pagerBar";
import moment from "moment";

Vue.use(VCharts);
export default {
  components: {
    pagerBar,
    echarts,
  },
  name: "Dashboard",
  data() {
    return {
      isShowActive: true,
      periodList: [],
      dataList: [],
      ActivyTenantList: [],
      ActivyTenantListFor5: [],
      datePeriod: "",
      cardopenloading: false,
      card2openloading: false,
      card3openloading: false,
      allBrandOrStore: { brands: 0, stores: 0 },
      allVouchers: {
        allVoucherAmts: 0,
        allVoucherNums: 0,
        voucherAmtByDay: 0,
        voucherNumByDay: 0,
        allOrderNums: 0,
        orderNumByDay: 0,
      },
      ChartReportApi: config.BASE_Middle_API + "ChartReport",
      AuditLogApi: config.BASE_Middle_API + "AuditLog",
      GetAuditLogApi: config.BASE_Middle_API + "AuditLog/GetAuditLogs",
      form: {},
      labelPosition: "left",
      value6: "",
      chart: null,
      activeUsers: [],
      clientLogs: [],
      queryParam: {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      listLoading: false,
      extend: {
        series: {
          label: {
            normal: {
              show: true,
            },
          },
        },
      },
      histogramChartDataWeek: {
        columns: [],
        rows: [],
      },
      histogramChartSettingsWeek: {},
      histogramChartMarkLine: {},
      title: {
        show: true, //显示策略，默认值true,可选为：true（显示） | false（隐藏）
        text: "", //主标题文本，'\n'指定换行
        target: null, //指定窗口打开主标题超链接，支持'self' | 'blank'，不指定等同为'blank'（新窗口）
        subtext: "", //副标题文本，'\n'指定换行
        x: "center", //水平安放位置，默认为'left'，可选为：'center' | 'left' | 'right' | {number}（x坐标，单位px）
        y: "center", //垂直安放位置，默认为top，可选为：'top' | 'bottom' | 'center' | {number}（y坐标，单位px）
        padding: 4, //标题内边距，单位px，默认各方向内边距为5，接受数组分别设定上右下左边距
        itemGap: 10, //主副标题纵向间隔，单位px，默认为10
        textAlign: null, //水平对齐方式，默认根据x设置自动调整，可选为： left' | 'right' | 'center
        backgroundColor: "rgba(0,0,0,0)", //标题背景颜色，默认'rgba(0,0,0,0)'透明
        borderColor: "#ccc", //标题边框颜色,默认'#ccc'
        borderWidth: 0, //标题边框线宽，单位px，默认为0（无边框）
        zlevel: 0, //一级层叠控制。默认0,每一个不同的zlevel将产生一个独立的canvas，相同zlevel的组件或图标将在同一个canvas上渲染。zlevel越高越靠顶层，canvas对象增多会消耗更多的内存和性能，并不建议设置过多的zlevel，大部分情况可以通过二级层叠控制z实现层叠控制。
        z: 6, //二级层叠控制，默认6,同一个canvas（相同zlevel）上z越高约靠顶层。
        textStyle: {
          //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
          // fontFamily: 'Arial, Verdana, sans...',
          fontSize: 20,
          color: "black",
          // fontWeight: 'normal',
        },
        subtextStyle: {
          fontSize: 30,
          color: "black",
          fontStyle: "normal",
          fontWeight: "normal",
        },
      },
      ringChartData: {
        columns: [],
        rows: [],
      },
      ringChartSettings: {
        dimension: "模块",
      },
    };
  },
  created() {
    this.getBrandStores();
    this.getTop5();
    this.GetTenantDistributions();

    this.getAllOrderPer();
  },
  mounted() {
    //this.initChart()
  },
  methods: {
    mapFn(mapData) {
      const _this = this;
      // 基于准备好的dom，初始化echarts实例
      // var mapChart = this.$echarts.init(this.$refs.mapChart);
      let mapDiv = document.getElementById("mapChart");
      let mapChart = echarts.init(mapDiv);
      mapChart.setOption({
        backgroundColor: "", //背景颜色
        title: {
          text: "客户分布",
          color: "#fff",
          x: "center",
        },
        dataRange: {
          show: false,
          min: 0,
          max: 1000,
          text: ["High", "Low"],
          realtime: true,
          calculable: true,
          color: ["orangered", "yellow", "lightskyblue"],
        },
        // 提示框，鼠标移入
        tooltip: {
          show: true, //鼠标移入是否触发数据
          trigger: "item", //出发方式
          formatter: function(e) {
            if (e.data != null || e.data != undefined) {
              let context = `
               <div>
                   <p><b style="font-size:15px;">${e.data.name}</b></p>
                   <p class="tooltip_style"><span class="tooltip_left">客户数量</span><span class="tooltip_right">${
                     e.data.value
                   }</span></p>
               </div>
            `;
              return context;
            }
          },
        },
        //配置地图的数据，并且显示
        series: [
          {
            name: "地图",
            type: "map", //地图种类
            map: "china", //地图类型。
            data: mapData,
            itemStyle: {
              //地图区域的多边形 图形样式。
              emphasis: {
                //高亮状态下的样试
                label: {
                  show: true,
                },
              },
            },
            zoom: 1.2, //放大比例
            label: {
              //图形上的文本标签，可用于说明图形的一些数据信息
              show: true,
            },
          },
        ],
      });

      window.addEventListener("resize", () => {
        // 自动渲染echarts
        mapChart.resize();
      });
    },
    showAcitiveOr() {
      const _this = this;
      if (!_this.isShowActive) {
        _this.getLastTop5();
      } else {
        _this.getTop5();
      }
    },
    changeDatePeriod(val) {
      this.histogramChartData();
    },
    GetTenantDistributions() {
      const _this = this;
      AjaxHelper.get(_this.ChartReportApi + "/GetTenantDistributions")
        .then(function(response) {
          if (response.success) {
            _this.dataList = response.result;
            _this.mapFn(_this.dataList);
          }
          _this.card3openloading = false;
        })
        .catch(function(error) {
          _this.card3openloading = false;
        });
      _this.card3openloading = true;
    },
    getTableData(d) {
      const _this = this;
      _this.clientLogs = d;
    },
    getAllOrderPer() {
      const _this = this;
      const arrayNew = [];
      _this.card3openloading = true;
      AjaxHelper.get(_this.ChartReportApi + "/GetAllOrderPer", {
        datePeriod: _this.datePeriod,
      })
        .then(function(response) {
          if (response.success) {
            _this.ringChartData.columns = response.result.columns;
            _this.ringChartData.rows = JSON.parse(response.result.rows);
          }
          _this.title.subtext = _this.allVouchers.allOrderNums;
          _this.title.text = "总数量";
          _this.card3openloading = false;
          _this.getAllVouchers();
        })
        .catch(function(error) {
          _this.card3openloading = false;
        });
    },
    histogramChartData() {
      const _this = this;
      const arrayNew = [];
      if (_this.datePeriod == "全部") {
        _this.datePeriod = "";
      }
      _this.card2openloading = true;
      AjaxHelper.get(_this.ChartReportApi + "/GetAllDataByMonth", {
        datePeriod: _this.datePeriod,
      })
        .then(function(response) {
          if (response.success) {
            _this.histogramChartDataWeek.columns = response.result.columns;
            _this.histogramChartDataWeek.rows = JSON.parse(
              response.result.rows
            );
            _this.getAllDataByYear();
          }
          _this.card2openloading = false;
        })
        .catch(function(error) {
          _this.card2openloading = false;
        });
    },
    getAllDataByYear() {
      const _this = this;
      _this.card2openloading = true;
      AjaxHelper.get(_this.ChartReportApi + "/GetAllDataByYear")
        .then(function(response) {
          if (response.success) {
            _this.periodList = response.result;
            _this.periodList.unshift("全部");
          }
        })
        .catch(function(error) {});
    },
    getTop5() {
      const _this = this;
      _this.card2openloading = true;
      _this.ActivyTenantList = [];
      _this.ActivyTenantListFor5 = [];
      AjaxHelper.get(_this.ChartReportApi + "/GetTenantsIsActiveOr")
        .then(function(response) {
          if (response.success) {
            _this.ActivyTenantList = response.result;
            for (let i = 0; i < _this.ActivyTenantList.length; i++) {
              if (i < 5) {
                _this.ActivyTenantListFor5.push(_this.ActivyTenantList[i]);
              }
            }
            _this.card2openloading = false;
          }
        })
        .catch(function(error) {});
    },
    getLastTop5() {
      const _this = this;
      _this.ActivyTenantList = [];
      _this.ActivyTenantListFor5 = [];
      _this.card2openloading = true;
      AjaxHelper.get(_this.ChartReportApi + "/GetTenantsIsActiveOr")
        .then(function(response) {
          if (response.success) {
            _this.ActivyTenantList = response.result;
            for (let i = _this.ActivyTenantList.length - 1; i > 0; i--) {
              if (_this.ActivyTenantListFor5.length < 5) {
                _this.ActivyTenantListFor5.push(_this.ActivyTenantList[i]);
              }
            }
            _this.card2openloading = false;
          }
        })
        .catch(function(error) {});
    },
    getBrandStores() {
      const _this = this;
      _this.cardopenloading = true;
      AjaxHelper.get(_this.ChartReportApi + "/GetAllBrandOrStore")
        .then(function(response) {
          if (response.success) {
            _this.allBrandOrStore = response.result;
          }
        })
        .catch(function(error) {});
    },
    getAllVouchers() {
      const _this = this;
      AjaxHelper.get(_this.ChartReportApi + "/GetAllVouchers")
        .then(function(response) {
          if (response.success) {
            _this.allVouchers = response.result;
            _this.histogramChartData();
          }
          _this.cardopenloading = false;
        })
        .catch(function(error) {
          _this.cardopenloading = false;
        });
    },
    getBck(index) {
      return `background: rgb(${43 + index * 20}, ${148 +
        index * 10}, 255) none repeat scroll 0% 0%;`;
    },
  },
};
</script>
<style scoped>
.chinaecharts {
  width: 50%;
  height: 50%;
}
#mapChart {
  width: 100%;
  height: 500px;
}
.bg-blue-sub-item {
  max-width: 120px !important;
  height: 50px;
  float: left;
  color: #fff;
  font-size: 15px;
  line-height: 50px;
  padding: 0 10px;
}
.note .text {
  font-size: 14px;
}

.note .item {
  margin-bottom: 18px;
}
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
.echarts-box {
  margin: 20px 0;
  padding: 20px;
  border-radius: 5px;
  background-color: #fff;
  .echarts {
    width: 100%;
    height: 600px;
  }
}

.panel-group {
  margin-top: 18px;
  margin-bottom: 18px;
}
.card-panel-col {
  margin-bottom: 32px;
  width: 115px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  float: left;
  margin-right: 18px;
}

.card-panel {
  height: 108px;
  font-size: 12px;
  position: relative;
  overflow: hidden;
  color: #666;
  background: #fff;
  box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
  border-color: rgba(0, 0, 0, 0.05);
  margin-left: 18px;
}

.card-panel .card-panel-icon-wrapper {
  color: #fff;
}

.card-panel .card-panel .icon-people {
  background: #40c9c6;
}

.card-panel .card-panel .icon-message {
  background: #36a3f7;
}

.card-panel .card-panel .icon-money {
  background: #f4516c;
}

.card-panel .card-panel .icon-shopping {
  background: #34bfa3;
}

.card-panel .icon-people {
  color: #40c9c6;
}

.card-panel .icon-message {
  color: #36a3f7;
}

.card-panel .icon-money {
  color: #f4516c;
}

.card-panel .icon-shopping {
  color: #34bfa3;
}

.card-panel .card-panel-icon-wrapper {
  float: left;
  margin: 14px 0 0 14px;
  padding: 16px;
  transition: all 0.38s ease-out;
  border-radius: 6px;
}

.card-panel .card-panel-icon {
  float: left;
  font-size: 48px;
}

.card-panel .card-panel-description {
  // float: left;
  font-weight: bold;
  // margin-left: 30px;
  margin-top: 18px;
}
.card-panel .card-panel-description .card-panel-text {
  line-height: 16px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 16px;
  margin-bottom: 12px;
  text-align: center;
}

.card-panel .card-panel-description .card-panel-num {
  font-size: 36px;
  color: #f4516c;
}
.extoday {
  cursor: pointer;
}
.card-acuser-num {
  font-size: 30px;
  color: #40c9c6;
  text-align: center;
  display: flow-root;
  vertical-align: middle;
}

@media (max-width: 550px) {
  .card-panel-description {
    display: none;
  }

  .card-panel-icon-wrapper {
    float: none !important;
    width: 100%;
    height: 100%;
    margin: 0 !important;
  }
  .card-panel-icon-wrapper .svg-icon {
    display: block;
    margin: 14px auto !important;
    float: none !important;
  }
}

.el-card {
  min-width: 900px;
  height: auto !important;
}
.width70 {
  width: 70%;
  float: left;
}
.img-circle {
  border-radius: 50%;
}

.mytask {
  margin: -20px;
}

.mytask .task-li {
  float: left;
  border: 1px #eee solid;
  width: 33.33%;
  border-left: none;
  border-top: none;
  padding-bottom: 15px;
}

.mytask .task-li p {
  text-indent: 1em;
}

.box-daohang {
  height: 363px !important;
}

.box-daohang p {
  font-size: 14px;
}

.box-daohang p .el-button {
  border: 1px #409eff solid;
  color: #409eff;
}

.touxiang {
  width: 42px;
  height: 42px;
}

.touxiang img {
  width: 100%;
}
.box-dongt {
  height: 455px !important;
}
.box-dongt ul li {
  border-bottom: 1px #eee solid;
}

.box-dongt ul li p {
  font-size: 14px;
  margin-left: 20px;
}

.moreinfo {
  cursor: pointer;
  color: #409eff;
}
</style>
